'use client';

import { useTranslations } from 'next-intl';
import type { HeroWordmarkVariant } from '../HeroSection/HeroWordmark';
import { HOME_MEDIA } from '../homeMedia';
import { ShowcaseContent } from '../ShowcaseStage/ShowcaseContent';
import { FeatureCard } from './FeatureCard';

interface GalleryScreenProps {
  /** 字标徽章版本，默认 Q3；第三屏传 's1'。 */
  variant?: HeroWordmarkVariant;
  /** 首个案例的视频路径。 */
  videoSrc?: string;
  /** 首个案例的视频封面。 */
  poster?: string;
  /** 主 CTA 文案 key（showcase 命名空间下），默认 createNow（立即创作）；第三屏传 tryNow。 */
  createLabelKey?: 'createNow' | 'tryNow';
  /** 主 CTA 跳转，默认 /home；S 模块传 /vidu-stream。 */
  createHref?: string;
  /** 案例文案组，默认 cases（Q3）；第三屏传 s1Cases（S1 实时交互）。 */
  casesKey?: 'cases' | 's1Cases';
}

/**
 * 卡片屏：大圆角卡片铺满视频，卡内文案复用 ShowcaseContent。
 * 第二屏用 Q3 字标，第三屏用 S1。
 */
export const GalleryScreen = ({
  variant = 'q3',
  videoSrc = HOME_MEDIA.q43.videoSrc,
  poster = HOME_MEDIA.q43.poster,
  createLabelKey = 'createNow',
  createHref = '/home',
  casesKey = 'cases',
}: GalleryScreenProps) => {
  const t = useTranslations('home3.showcase');

  return (
    <section className="relative z-[15] flow-root h-full md:h-auto">
      <FeatureCard
        media={{
          videoSrc,
          poster,
          alt: t(`${casesKey}.case1.title`),
        }}
      >
        <ShowcaseContent
          variant={variant}
          title={t(`${casesKey}.case1.title`)}
          subtitle={t(`${casesKey}.case1.subtitle`)}
          createLabel={t(createLabelKey)}
          createHref={createHref}
        />
      </FeatureCard>
    </section>
  );
};
